/** @prettier */

/**
 * ユーザ削除ダイアログ
 */

import {Dialog, DialogTitle, DialogContent, DialogActions} from '@mui/material';
import {useState} from 'react';
import {useParams} from 'react-router-dom';

//MTH component import
import APIErrorMessage from '../../component/APIErrorMessage';
//API import
import {deleteSettingSites} from '../../API/API_Collection';
//interface import
import * as apiIF from '../../Type/api';
//Style import
import '../../css/common/common.css';
import {useTranslation} from 'react-i18next';
import {PrimaryButton, SecondaryButton} from '../../component/BasicButton';
import ChangePayingUserAuthorityMessage from '../../component/ChangePayingUserAuthorityMessage';

const UserDeleteDialog = (props: {
  authorityIDInfo: apiIF.resParameters.userAuthority;
  setAuthInfoChange: React.Dispatch<React.SetStateAction<boolean>>;
  isOpenDialog: boolean;
  setIsOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  //パスパラメータ取得
  const {siteID} = useParams();

  const [errorCode, setErrorCode] = useState(''); //削除失敗時のcode格納用変数
  const [errorParam, setErrorParam] = useState(''); //削除失敗時のparameter格納用変数
  const [isOpenErrorDialog, setIsOpenErrorDialog] = useState(false); //APIエラー時エラーメッセージ表示
  const [apiWait, setAPIWait] = useState(false); //API応答待ちフラグ

  const trans = useTranslation().t; //翻訳関数

  /**
   * OKボタン押下時処理
   */
  const handleDelete = () => {
    //パスパラメータを取得できない場合
    if (siteID === undefined) {
      return;
    }

    setAPIWait(true);

    //サイトのユーザーを削除する
    const deleteInfo: apiIF.reqParameters.deleteSettingSites = {
      'user-id': [props.authorityIDInfo['user-id']],
    };
    deleteSettingSites(siteID, deleteInfo)
      .then(response => {
        //ユーザー登録時に一覧を更新する
        props.setAuthInfoChange(true);
        handleClose();
      })
      .catch(err => {
        setIsOpenErrorDialog(true);
        setErrorCode(err.response.data.code);
        setErrorParam(err.response.data.parameter);
      })
      .finally(() => {
        setAPIWait(false);
      });
  };
  /**
   * CANCELボタン押下時処理
   */
  const handleClose = () => {
    props.setIsOpenDialog(false);
  };

  return (
    <>
      <Dialog
        open={props.isOpenDialog}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        id="mv-form-delete-dialog-security">
        <DialogTitle id="form-dialog-title">
          {trans('UserDeleteDialog.dialogBox.title')}
        </DialogTitle>
        <DialogContent>
          <div>
            {trans('UserDeleteDialog.dialogBox.email')}
            &nbsp;:&nbsp;
            {props.authorityIDInfo['e-mail']}
          </div>
          <p>{trans('UserDeleteDialog.dialogBox.msg')}</p>
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            disabled={apiWait}
            onClick={handleClose}
            buttonText={trans('UserDeleteDialog.dialogBox.buttonTxt.cancel')}
            id={`mv-DeleteCancelBtn${props.authorityIDInfo['e-mail'].replace(
              '@',
              ''
            )}`}
          />
          <PrimaryButton
            onClick={handleDelete}
            buttonText={trans('UserDeleteDialog.dialogBox.buttonTxt.ok')}
            id={`mv-DeleteOkBtn${props.authorityIDInfo['e-mail'].replace(
              '@',
              ''
            )}`}
            apiWait={apiWait}
          />
        </DialogActions>
      </Dialog>
      {errorCode === 'DELETE_ADMIN_USER_FORBIDDEN' ? (
        <ChangePayingUserAuthorityMessage
          errorCode={errorCode}
          gwNameList={errorParam}
          open={isOpenErrorDialog}
          setOpen={setIsOpenErrorDialog}
          id={`mv-ChangePayingUserAuthorityErrDlgBtn${props.authorityIDInfo[
            'e-mail'
          ].replace('@', '')}`}
        />
      ) : (
        <APIErrorMessage
          open={isOpenErrorDialog}
          setOpen={setIsOpenErrorDialog}
          id={`mv-DeleteErrDlgBtn${props.authorityIDInfo['e-mail'].replace(
            '@',
            ''
          )}`}
        />
      )}
    </>
  );
};
export default UserDeleteDialog;
